import React, { useState } from 'react';
import { connect } from 'react-redux';

import { signout } from 'redux/actions/pages';
import { NAV_LINKS, LOGO_SRC } from './homeContent';
import { isLoggedInUser, isTeacherUser, teacherPanelUrlFor } from './authLinks';

// Shared top bar of the public site. `hideSignin` drops the "Giriş Yap"
// button on the sign-in page itself.
const SiteNav = ({ currentUser, token, signout, hideSignin }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const isLoggedIn = isLoggedInUser(currentUser);
  const isTeacher = isTeacherUser(currentUser);
  const teacherPanelUrl = teacherPanelUrlFor(token);

  const closeMenu = () => setMenuOpen(false);

  const signoutClicked = (e) => {
    e.preventDefault();
    signout({ email: currentUser.email });
  };

  return (
    <header className="op-nav">
      <div className="op-nav__in">
        <a className="op-brand" href="/" aria-label="Okuma Platformu ana sayfa">
          <img src={LOGO_SRC} alt="Okuma Platformu" />
        </a>

        <nav
          id="op-menu"
          className={`op-nav__menu${menuOpen ? ' op-nav__menu--open' : ''}`}
          aria-label="Ana menü"
        >
          <ul className="op-nav__links">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={closeMenu}>
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a href="/contact">İletişim</a>
            </li>
          </ul>
          <div className="op-nav__actions">
            {isTeacher ? (
              <a className="op-btn op-btn--primary op-btn--sm" href={teacherPanelUrl}>
                Öğretmen Paneli
              </a>
            ) : null}
            {isLoggedIn ? (
              <a className="op-btn op-btn--ghost op-btn--sm" href="/" onClick={signoutClicked}>
                Çıkış
              </a>
            ) : (
              <>
                <a className="op-btn op-btn--ghost op-btn--sm" href="/buy-now">
                  Satın Al
                </a>
                {hideSignin ? null : (
                  <a className="op-btn op-btn--primary op-btn--sm" href="/signin">
                    Giriş Yap
                  </a>
                )}
              </>
            )}
          </div>
        </nav>

        <button
          type="button"
          className="op-nav__toggle"
          aria-controls="op-menu"
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.auth?.currentUser,
  token: state.auth?.token,
});

const mapDispatchToProps = {
  signout,
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteNav);
